import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Calendar, Phone } from 'lucide-react';

const TaskCTA = ({
  onCalculationClick,
  onCallbackClick,
  showRequestButton = true,
  title = 'Остались вопросы?',
}) => {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <Card className="bg-gradient-to-br from-accent/8 via-card/80 to-card/80 border-accent/20">
        <CardContent className="p-8 md:p-12">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            {title}
          </h2>
          <p className="text-muted-foreground mb-8 max-w-xl">
            Мы подберём решение без лишних затрат — быстро и с максимальной выгодой.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              className="bg-accent hover:bg-accent/90 text-accent-foreground font-medium h-12 px-8"
              onClick={onCalculationClick}
            >
              <Calendar className="w-4 h-4 mr-2" />
              Обсудить задачу
            </Button>
            {showRequestButton && (
              <Button
                variant="outline"
                className="h-12 px-8"
                onClick={onCallbackClick}
              >
                <Phone className="w-4 h-4 mr-2" />
                Отправить запрос
              </Button>
            )}
          </div>
        </CardContent>
      </Card>
    </section>
  );
};

export default TaskCTA;

